import { gql, useMutation } from '@apollo/client';

export const REACTIVATE_PROPERTY_MUTATION = gql`
    mutation ReactivateProperty($id: ID!, $activatedAt: String, $expiresAt: String) {
        updateProperty(id: $id, activatedAt: $activatedAt, expiresAt: $expiresAt) {
            id
            activatedAt
            expiresAt
            activations
        }
    }
`;

const useReactivateProperty = ({ onCompleted, onError }) =>
    useMutation(REACTIVATE_PROPERTY_MUTATION, {
        onCompleted,
        onError,
    });

export default useReactivateProperty;
